export const SET_PAGE_LOADER = () =>{
    return{
        type: "PAGE_LOADER"
    }
}